import { useEffect } from "react"
import { MEDIA_QUERIES } from "@/constants/ui"

import { setViewSize, ViewSize } from "@/lib/storage/app-slice"
import { useAppDispatch } from "@/lib/storage/hooks"

export function ViewSizeHandler() {
  return <Sizer />
}

// Reads the viewport itself rather than through useMediaQuery: it renders
// nothing, so it has no server markup to match, and the first view size it
// stores must be the real one. Code that acts once on the first view size (chat
// init on an embedded phone) would otherwise act on the hydration default.
function Sizer() {
  const dispatch = useAppDispatch()

  useEffect(() => {
    const split = window.matchMedia(MEDIA_QUERIES.split)
    const xs = window.matchMedia(MEDIA_QUERIES.xsMax)
    const storeViewSize = () => {
      let viewSize: ViewSize = "sm"
      if (split.matches) viewSize = "split"
      else if (xs.matches) viewSize = "xs"
      dispatch(setViewSize(viewSize))
    }

    storeViewSize()
    split.addEventListener("change", storeViewSize)
    xs.addEventListener("change", storeViewSize)
    return () => {
      split.removeEventListener("change", storeViewSize)
      xs.removeEventListener("change", storeViewSize)
    }
  }, [dispatch])

  return null
}
